export default function DeleteElementById(id, elements) {
    return (function r(elements) {
        for (const element of elements) {
            if (element.props.id === id) {
                elements = elements.filter(_element => _element !== element);
            }

            if (element.children && element.children.length > 0) {
                element.children = r(element.children);
            }
        }

        return elements;
    })(elements);
}
